import * as z from "zod/v4";

export const getOmsTiktokIntegration = {
  name: "getOmsTiktokIntegration" as const,
  input: z.object({}),
  output: z.object({ exists: z.boolean() }),
};
